import { useState } from 'react';
import API from '../api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function EditCustomerModal({ customer, onClose, onCustomerUpdated }) {
  const [form, setForm] = useState({
    customer_number: customer.customer_number,
    company_name: customer.company_name,
    address_for_field_engineer: customer.address_for_field_engineer,
    onsite_contact_name: customer.onsite_contact_name,
    onsite_contact_phone: customer.onsite_contact_phone,
    onsite_contact_email: customer.onsite_contact_email,
    regular_business_hours: customer.regular_business_hours,
    emergency_business_hours: customer.emergency_business_hours,
    notes: customer.notes || '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

// Enviar modificaciones
const handleSubmit = async e => {
  e.preventDefault();

  if (!form.customer_number || !form.company_name) {
    toast.error("Customer Number and Company Name are required.");
    return;
  }

  if (!form.address_for_field_engineer || form.address_for_field_engineer.trim() === "") {
    toast.error("Address for Field Engineer must not be blank.");
    return;
  }

  if (form.onsite_contact_phone && !/^\d{10}$/.test(form.onsite_contact_phone)) {
    toast.error("Onsite contact phone must be exactly 10 digits.");
    return;
  }

  if (form.onsite_contact_email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.onsite_contact_email)) {
    toast.error("Please enter a valid email address.");
    return;
  }

  try {
    const payload = {
      ...form,
      customer_number: String(form.customer_number),
      onsite_contact_phone: form.onsite_contact_phone || null,
      onsite_contact_email: form.onsite_contact_email || null,
      onsite_contact_name: form.onsite_contact_name || null,
      regular_business_hours: form.regular_business_hours || null,
      emergency_business_hours: form.emergency_business_hours || null,
      notes: form.notes || null,
    };

    await API.put(`/customers/${customer.id}`, payload);

    toast.success("Customer updated successfully!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    onCustomerUpdated();
    onClose();
  } catch (err) {
    console.error("Update error:", err);
    toast.error('Error updating customer: ' + (err.response?.data?.message || err.message), {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};


  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-xl shadow-lg max-w-lg w-full">
        <h2 className="text-xl font-bold mb-4">Edit Customer</h2>

        {Object.keys(form).map((key) => (
          <div className="mb-3" key={key}>
            <label className="block text-sm text-gray-700 capitalize">{key.replace(/_/g, ' ')}</label>
            {key === 'notes' ? (
              <textarea
                name={key}
                value={form[key]}
                onChange={handleChange}
                rows="4"
                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="Add any additional notes or comments here..."
              />
            ) : (
              <input
                type="text"
                name={key}
                value={form[key]}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded"
              />
            )}
          </div>
        ))}

        <div className="flex justify-end space-x-3 mt-4">
          <button onClick={onClose} className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
          <button onClick={handleSubmit} className="bg-blue-600 text-white px-4 py-2 rounded">Save</button>
        </div>
      </div>
    </div>
  );
}

